import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import $ from 'jquery';

import { useAuthState } from "react-firebase-hooks/auth";

import { firebaseAuth } from './firebase/init-firebase';

import FullScreenLoader from './components/loaders/fullscreen-loader';

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const Categories = React.lazy(() => import('./pages/categories/categories'));
const Subcategories = React.lazy(() => import('./pages/categories/subcategories'));

const Dashboard = React.lazy(() => import('./pages/dashboard/dashboard'));
const NewDashboard = React.lazy(() => import('./pages/dashboard/new_dashboard'));

const HomeComponents = React.lazy(() => import ('./pages/home/components'))

const ProductList = React.lazy(() => import('./pages/products/product-list'));
const NewProductList = React.lazy(() => import('./pages/products/new-product-list'));
const ProductVariantListList = React.lazy(() => import('./pages/products/variants/variant-list'));
const ProductDetails = React.lazy(() => import('./pages/products/product-details'));

const OrderList = React.lazy(() => import('./pages/orders/order_list'));
const DelhiveryPickupList = React.lazy(() => import('./pages/orders/delhivery_pickup_list'));
const OrderDetails = React.lazy(() => import('./pages/orders/order_details'));
const PinCodeList = React.lazy(() => import('./pages/pincodes/pincode_list'));
const PinCodeDetails = React.lazy(() => import('./pages/pincodes/pincode_details'));
const BrandList = React.lazy(() => import('./pages/products/brand_list'));
const Deals = React.lazy(() => import('./pages/deals/deals'));
const FeaturedProducts = React.lazy(() => import('./pages/deals/featured_products'));

const Users = React.lazy(() => import('./pages/users/users'));

export const protectedRoutesList = [
    { path: '/homeComponents', exact: true, name: 'HomeComponents', component: HomeComponents },
    { path: '/orders', exact: true, name: 'Orders', component: OrderList },
    { path: '/delhivery_pickup_orders', exact: true, name: 'Delhivery Pickup Orders', component: DelhiveryPickupList },
    { path: '/pincodes', exact: true, name: 'Pin Codes', component: PinCodeList },
    { path: '/pincodes/manage', exact: true, name: 'Pin Codes', component: PinCodeDetails },
    { path: '/orders/edit/:orderDocId', exact: true, name: 'Order Details', component: OrderDetails },
    { path: '/productCategories', exact: true, name: 'Categories', component: Categories },
    { path: '/productSubcategories', exact: true, name: 'Subcategories', component: Subcategories },
    { path: '/dashboard', exact: true, name: 'Dashboard', component: Dashboard },
    { path: '/products', exact: true, name: 'ProductList', component: NewProductList },
    { path: '/productBrands', exact: true, name: 'Product Brands', component: BrandList },
    { path: '/productVariants', exact: true, name: 'ProductVariantListList', component: ProductVariantListList },
    { path: '/products/add', name: 'Product Details', component: ProductDetails },
    { path: '/products/edit/:productId', name: 'Product Details', component: ProductDetails },
    { path: '/deals', name: 'Deals', component: Deals },
    { path: '/featuredProducts', name: 'Featured Products', component: FeaturedProducts },
    { path: '/users', exact: true, name: 'Users', component: Users },
];

const ProtectedRoute = ({ component: Component, ...rest }) => {

    const [user, loading, error] = useAuthState(firebaseAuth);

    if (loading) return <FullScreenLoader />

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                return user
                ? <Component {...routeProps} />
                : <Redirect to="/auth/sign-in" />
            }}
        />
    )
}
export default ProtectedRoute;